import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_contact_key_entity_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface; 
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_link_guid: fromDatatype.GuidDataFieldInterface;
  probabiity: fromDatatype.NumericDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_contact_key_entity_link_RowClass
  implements bl_crm_contact_key_entity_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface; 
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_link_guid: fromDatatype.GuidDataFieldInterface;
  probabiity: fromDatatype.NumericDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}